import { object, number, string } from 'yup';

export default object().shape({
  email: string()
    .email('Please enter a valid email')
    .required('Please enter the email'),
  property: object().shape({
    propertyID: number().required('Please select your building address'),
    address: string().required('Please select your building address'),
  }),
  buildingName: string().when('property', {
    is: (val) => val.buildingsNames && val.buildingsNames.length > 0,
    then: string().required('Please select building name'),
  }),
  unitNumber: string().required('Please enter unit number'),
  bedroomsCount: string().required('Please select number of bedrooms'),
  residentName: string().matches(
    /\S+\s\S+$/,
    'Enter the full name (and check for typos)'
  ),
});
